import axios from 'axios'
import store from '@/store'
import {changeFormShapeIfItIsPhone, getBaseDomain} from '../class/Converter'
import router from "@/router";
import {toast} from '../class/Notification'

export function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function deleteCookie(cname = 'token') {
    let domain = getBaseDomain(false).split('.').slice(-2).join('.');
    document.cookie = `${cname}=; path=/; domain=.${domain}; expires=` + new Date(0).toUTCString();
}

export default {
    namespaced: true,
    state: {
        cellphoneForForgetPassword: null,
        formStepOnRegisterWithVerifyPhone: 1
    },
    mutations: {
        setUser(state, user) {
            store.dispatch('User/setUser', user)

        },
        setToken(state, token) {
            store.dispatch('User/setToken', token)
        },
        setCellphoneForForgetPassword(state, phone) {
            state.cellphoneForForgetPassword = phone
        },
        setFormStepOnRegisterWithVerifyPhone(state, step) {
            state.formStepOnRegisterWithVerifyPhone = step
        }
    },
    actions: {
        login({commit}, form,) {
            form = changeFormShapeIfItIsPhone(form)
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            let url = `/auth/login?${captcha}`
            if (form.without_captcha) {
                url = `/auth/login-two-step`
            }

            let res = axios.post(url, form);

            res.then(res => {
                store.dispatch('User/setUserState', res)
                const user = store.getters['User/getProfile']
                const userFullName = `${user.name} ${user.last_name}`;

                if (form.withoutRedirect === undefined) {
                    toast(`${userFullName} خوش آمدید.`, `${userFullName} خوش آمدید.`)
                    router.push({name: 'Home'})
                }

            }).catch(error => {
                store.dispatch('Captcha/getCaptcha')
                console.log(error)
            })


            return res
        },
        async register({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            if (await store.dispatch('Chat/checkChatToken')) {
                form.chat_token = await store.dispatch('Chat/getChatToken')
            }
            axios.post(`/auth/register?${captcha}`, form).then(res => {
                store.dispatch('User/setUserState', res)
                store.dispatch('Chat/removeChatToken')
                router.push({name: 'Home'})
            })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    console.log(error)
                })
        },
        async attemptLogin({commit}) {
            let token = localStorage.getItem('token')
            let cookieToken = getCookie('token');
            if (cookieToken != '' && token == null) {
                token = cookieToken;
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            }

            if (token === null) {
                return
            }

            try {
                let res = await axios.get('/auth/me')
                const profile = res.data.data
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
                store.dispatch('User/setToken', token)
                store.dispatch('User/setProfile', profile)
            } catch (e) {
                localStorage.removeItem('token')
                deleteCookie('token')
                store.dispatch('User/setToken', null)
                store.dispatch('User/setProfile', null)
                return e
            }

        },
        sendCellPhoneVerificationCode({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            return axios.post(`/auth/phone/send/verification?${captcha}`, form)
        },
        verifyCellphone({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            axios.post(`/auth/phone/verified?${captcha}`, form).then(res => {
                store.commit('User/setUser', {...store.getters['User/getProfile'], cellphone_verified_at: new Date()})
                router.push({name: 'Home'})
                toast("شماره تلفن همراه با موفقیت تایید شد.", "شماره تلفن همراه تایید شد");

            })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    console.log(error)
                })
        },

        resendCellphoneVerificationCode({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            axios.post(`/auth/phone/send/verification?${captcha}`, form).then(res => {
                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            }).catch(error => {
                store.dispatch('Captcha/getCaptcha')
                console.log(error)
            })
        },
        removeProfileToken({commit}) {
            store.dispatch('User/setToken', null)
            store.dispatch('User/setProfile', null)
            localStorage.removeItem('token')
            deleteCookie('token')

        },
        logout({commit}, form = {withoutState: false}) {

            let req = axios.post('/auth/logout')

            if (form.withoutState != true) {
                req.then(res => {
                    store.dispatch('Authentication/removeProfileToken')
                    router.push({name: 'Home'})
                })
                    .catch(error => {
                        console.log(error)
                    })
            }

            return req
        },
        cellphoneForgetPassword({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            axios.post(`/auth/cellphone/forgot-password?${captcha}`, form).then(res => {
                commit('setCellphoneForForgetPassword', form)
                router.push({name: 'CellphoneResetPassword'})
                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    console.log(error)
                })
        },
        resendCodeForCellphoneForgetPassword({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            axios.post(`/auth/cellphone/forgot-password?${captcha}`, form).then(res => {
                commit('setCellphoneForForgetPassword', form)

                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    console.log(error)
                })
        },
        cellphoneResetPassword({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            axios.post(`/auth/cellphone/reset-password?${captcha}`, form).then(res => {
                router.push({name: 'Login'})
                toast(".رمز عبور ثبت شد", "رمز عبور با موفقیت ثبت شد");
            })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    console.log(error)
                })
        },
        verifyCellPhoneBeforeRegister({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            axios.post(`auth/verify-cell-phone-without-register?${captcha}`, form)
                .then(res => {
                    commit('setFormStepOnRegisterWithVerifyPhone', 2)
                    toast('کد تایید با موفقیت برای شما ارسال شد', 'کد تایید با موفقیت برای شما ارسال شد');
                })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    commit('setFormStepOnRegisterWithVerifyPhone', 1)
                    console.log(error)
                })
        },
        async registerWithVerifyCellPhone({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            if (await store.dispatch('Chat/checkChatToken')) {
                form.chat_token = await store.dispatch('Chat/getChatToken')
            }
            axios.post(`auth/register-after-verify-cell-phone?${captcha}`, form)
                .then(res => {
                    commit('setFormStepOnRegisterWithVerifyPhone', 2)
                    store.dispatch('User/setUserState', res)
                    store.dispatch('Chat/removeChatToken')
                    router.push({name: 'Home'})
                    toast('ثبت نام با موفقیت انجام شد', 'رمز عبور برای شما ارسال خواهد شد.');
                })
                .catch(error => {
                    store.dispatch('Captcha/getCaptcha')
                    commit('setFormStepOnRegisterWithVerifyPhone', 1)
                    console.log(error)
                })
        },
        loginWithSms({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            return axios.post(`auth/login-with-sms?${captcha}`, form)
        },
        loginWithSmsVerifyCellphone({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            return axios.post(`auth/login-with-sms-verify-cellphone?${captcha}`, form)
        },
        async loginWithSmsRegister({commit}, form) {
            const captcha = store.getters['Captcha/getCaptchaForUrl']
            if (await store.dispatch('Chat/checkChatToken')) {
                form.chat_token = await store.dispatch('Chat/getChatToken')
            }
            let res = axios.post(`auth/login-with-sms-register?${captcha}`, form)

            res.then(async (res) => {
                await store.dispatch('Chat/removeChatToken')
            })

            return res
        },
    },
    getters: {
        getCellphoneForForgetPassword: state => state.cellphoneForForgetPassword,
        getFormStepOnRegisterWithVerifyPhone: state => state.formStepOnRegisterWithVerifyPhone,
    }
}